"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLoginError = void 0;
const isLoginError = (url) => {
    if (!url)
        return false;
    return url === '/auth/login';
};
exports.isLoginError = isLoginError;
